/* eslint-disable */
import React, { useEffect } from 'react';
import {
    Box,
    List,
    ListItem,
    Card,
    CardContent,
    Typography,
    CircularProgress,
    Checkbox,
    Tooltip,
    IconButton,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import DataListRow from './dataListRow';
import { createTheme } from '@mui/material/styles';
import EnhancedTableToolbar from '../../sharedcomponents/tableToolbar/tableToolbar';
import Paging from '../../sharedcomponents/pagination/pagination';
import DraggableList from './draggableList';
import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import { useEventState } from '../../stores/eventStore';
import {
    useSearchObjState,
    setSearchObjState,
} from '../../hookState/SearchObjState';
import { useState, Downgraded } from '@hookstate/core';
import Title from '../../sharedcomponents/title/title';
import CircleIcon from '@mui/icons-material/Circle';
import Helper from '../../utility/helper';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import RemoveCircleOutlinedIcon from '@mui/icons-material/RemoveCircleOutlined';
import WindowAccordList from '../windowAccordianList/windowAccordianList';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    boxContent: {
        // paddingTop: theme.spacing(2),
    },
    listContent: {
        paddingBottom: 0,
        paddingTop: 0,
        zIndex: 0,
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
    wrapper: {
        position: 'relative',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        top: '7px',
    },
    icon: {
        fontSize: '1.5em',
    },
    count: {
        position: 'absolute',
        // lineHeight: 0.5,
        color: '#fff',
        fontWeight: 500,
        // top: '0.5em',
        fontSize: '0.65em',
    },
}));
const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};
const DataList = (props) => {
    const classes = useStyles();
    const [listData, setListData] = React.useState([]);
    const [allListData, setAllListData] = React.useState([]);
    const [filterListData, setFilterListData] = React.useState(null);
    const [search, setSearch] = React.useState('');
    const eventState = useEventState();
    const moduleIndex = useState(-1);
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const [checkAllSelect, setCheckAllSelect] = React.useState(false);
    const [filterVal, setFilterVal] = React.useState();
    const [hideSelectAll, setHideSelectAll] = React.useState(true);
    const [hideReject, setHideReject] = React.useState(true);
    const [hideApprove, setHideApprove] = React.useState(true);
    const [expanded, setExpanded] = React.useState(false);
    const info = Helper.getStorage('eventInfo');
    const getSearchObjState = useSearchObjState();

    useEffect(() => {
        if (props.allData) {
            setAllListData(props.allData)
        }
        if (
            props.showSearchRec &&
            props.data && (props.data.length != listData.length)
        ) {
            setListData(props.data);
        } else if (!props.showSearchRec) {
            setListData(props.data);
        }

        if (getSearchObjState.attach(Downgraded).get().search !== "" || (filterVal && Object.keys(filterVal).length > 0)) {
            filterDataListHandler(getSearchObjState.attach(Downgraded).get().search, filterVal, props.allData, props.data);
        }
        else {
            if (listData && listData.length == 0 && filterListData == null) {
                setFilterListData(props.data);
            } else if (
                props.showSearchRec &&
                props.data && (props.data.length != listData.length)
            ) {
                setFilterListData(props.data);
            } else if (!props.showSearchRec) {
                setFilterListData(props.data);
            }
        }

        if (props.filterChangeVal) {
            setListData(props.data);
            setFilterListData(props.data);
            handleFilterChangeValue(filterVal);
            // props.setFilterChangeVal(false);
        }
    }, [props.allData, props.data, props.showSearchRec, props.filterChangeVal]);

    useEffect(() => {
        if (
            eventState &&
            eventState.eventDetail.get() != null &&
            props.moduleToShow != undefined
        ) {
            getModuleDetailsData();
        }
    }, [props])

    useEffect(() => {
        if (props.hideSelectAll) {
            setHideSelectAll(false);
        }
        if (props.hideReject) {
            setHideReject(false);
        }
        if (props.hideApprove) {
            setHideApprove(false);
        }
    }, [props.hideSelectAll, props.hideReject, props.hideApprove])

    useEffect(() => {

        let notSelected = filterListData ? filterListData.some(i => !i.selected) : true;
        setCheckAllSelect(!notSelected)

    }, [filterListData])

    const getModuleDetailsData = () => {
        const index = eventState.eventDetail
            .get()
            .moduleDetails.findIndex((element) => {
                if (
                    element.moduleName ===
                    (props.titleHeader ? props.titleHeader : props.moduleToShow)
                ) {
                    return true;
                }
                else {
                    return false
                }
            });
        if (!(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo) || Helper.isEventStaff(userInfo))) {
            moduleIndex.set(index);
        }
    };
    const handleFilterChangeValue = (data) => {
        let filterObj = data;
        setFilterVal(filterObj);
        setSearchObjState({
            ...getSearchObjState.attach(Downgraded).get(),
            type: filterObj
        });
        filterDataListHandler(search, filterObj);
    };

    const handleOnChange = (event) => {
        let str = event.target.value;
        const value = str.replace(/^\s+/g, '');
        setSearch(value);
        setSearchObjState({
            ...getSearchObjState.attach(Downgraded).get()
        });
        filterDataListHandler(value, filterVal);
    };

    const filterDataListHandler = (searchValue, filterObj, allData = null, data = null) => {
        let finalData = [];
        if (allData && allData.length > 0 || data && data.length > 0) {
            finalData = allData.length > 0 ? [...allData] : [...data];
        }
        else {
            finalData = allListData.length > 0 ? [...allListData] : [...listData];
        }

        if (searchValue || (filterObj && Object.keys(filterObj).length > 0)) {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(true);
            }

            let modifyList = [];

            if (filterObj) {
                modifyList = finalData.filter((item) => {
                    const data = item.actualData;
                    if (filterObj) {
                        return Object.keys(filterObj).every((filter) => {
                            let val =
                                typeof filterObj[filter] === 'string' &&
                                    filter === 'transportType'
                                    ? filterObj[filter].toLowerCase()
                                    : filterObj[filter];
                            //added below code for request status
                            if (filter === 'requestStatus') {
                                if (val === 'Not Approved') {
                                    val = 'Rejected'
                                }
                                return data[filter] === val;
                            }
                            else
                                return val.includes(data[filter]);
                        });
                    }
                });
            }
            if (searchValue) {
                if (modifyList.length > 0) {
                    finalData = modifyList;
                    modifyList = [];
                }

                finalData.forEach((item) => {
                    let data = item.actualData;
                    let keys = Object.keys(data);
                    keys.forEach((key) => {
                        if (
                            typeof data[key] === 'string' &&
                            data[key].toLowerCase().indexOf(searchValue.toLowerCase()) >
                            -1
                        ) {
                            if (modifyList.indexOf(item) == -1)
                                modifyList.push(item);
                        }
                    });
                });
            }
            const uniqueList = modifyList;//[...new Set(modifyList.map(obj => obj))];
            setFilterListData(uniqueList);
            if (props.filterListData) props.filterListData(uniqueList);

        } else {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(false);
            }

            setFilterListData(finalData);

            if (props.filterListData)
                props.filterListData(finalData);
        }
    }
    const onCheckSelect = (event, index) => {
        let newFilterList = [...filterListData];
        newFilterList[index]['selected'] = event.target.checked;
        if (checkAllSelect === true) {
            if (event.target.checked === true) {
                setCheckAllSelect(true);
            } else {
                setCheckAllSelect(false);
            }
        } else {
            let filteredAllSelect = filterListData.filter(
                (item) => item.selected === false
            );
            if (filteredAllSelect.length === 0) {
                setCheckAllSelect(true);
            } else {
                setCheckAllSelect(false);
            }
        }

        setFilterListData(newFilterList);
        if (props.filterListData)
            props.filterListData(newFilterList);
    };
    const onCheckSelectAll = (e) => {
        let newFilterList = [...filterListData];
        newFilterList.forEach((item) => {
            item.selected = e.target.checked;
        });
        setCheckAllSelect(e.target.checked);
        setFilterListData(newFilterList);
        if (props.filterListData)
            props.filterListData(newFilterList);
    };
    const onExpand = () => {
        setExpanded(true);
    }
    const onCollapse = () => {
        setExpanded(false);
    }
    const statusValues = (value, status) => {
        return (
            <Box
                className={classes.wrapper}
                style={{
                    fontSize: 14,
                }}>
                <CircleIcon
                    style={{
                        color:
                            status === 'Pending'
                                ? '#C59B64'
                                : status === 'Approved'
                                    ? '#169D3C'
                                    : 'red',
                    }}
                    className={classes.icon}
                />
                <Typography component="span" className={classes.count}>
                    {value}
                </Typography>
            </Box>
        );
    };
    const handleEditAll = () => {
        props.editAllToggle();
    };
    const handleHotelSave = () => {
        let newFilterList = [...filterListData];
        props.editAll(newFilterList);
    };




    const renderYesNoCount = () => {
        let yescount = 0;
        let nocount = 0;
        let count = 0;

        const distinctUser = props.allData?.filter((item, index, self) => {
            return index === self.findIndex((t) => (
                t.actualData.addedFor === item.actualData.addedFor
            ));
        });

        if (distinctUser) {
            if (
                distinctUser.length > 0 &&
                distinctUser[0].actualData.hotelAgentRoomRequest.length > 0
            ) {
                yescount =
                    distinctUser[0].actualData.hotelAgentRoomRequest[0]
                        .acceptedCount;
                nocount =
                    distinctUser[0].actualData.hotelAgentRoomRequest[0]
                        .rejectedCount;
                count =
                    distinctUser[0].actualData.hotelAgentRoomRequest[0]
                        .notApplicableCount;
            }
        }



        // if (distinctUser) {
        //     distinctUser.length > 0 &&
        //         distinctUser.forEach((item) => {
        //             if (item.actualData.hotelAgentRoomRequest.length > 0) {
        //                 item.actualData.hotelAgentRoomRequest.forEach(
        //                     (elem) => {
        //                         if (elem.isAgentRoomRequestAccepted == true) {
        //                             yescount++;
        //                         } else if (
        //                             elem.isAgentRoomRequestAccepted == false
        //                         ) {
        //                             nocount++;
        //                         }
        //                     }
        //                 );
        //             } else {
        //                 count++;
        //             }
        //         });
        // }
        return (
            <Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                    }}>
                    <Box>
                        <Typography
                            variant="subtitle2"
                            color={'primary'}
                            component={'span'}>
                            Do you want to reserve one (1) hotel room for
                            your certified agent (at the agent’s expense)?
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '350px',
                            alignItems: 'center',
                            justifyContent: 'center',
                            ml: '20px',
                            pb: '2px',
                        }}>
                        <Box
                            sx={{
                                width: '100%',
                                //flexBasis: '180px',
                                flexGrow: 1,
                                margin: '10px 0px 5px 10px',
                                flexWrap: 'wrap',
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'left',
                                    alignItems: 'center',
                                    width: '100%',
                                    gap: '10px',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={500}
                                    color="primary">
                                    <span
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}>
                                        Yes :
                                    </span>
                                </Typography>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: '#DFE3EC',
                                        borderRadius: '14px',
                                        width: '50px',
                                        //padding:'2px'
                                    }}>
                                    {yescount}
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                //flexBasis: '180px',
                                flexGrow: 1,
                                margin: '5px 0px 0px 10px',
                                flexWrap: 'wrap',
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'left',
                                    alignItems: 'center',
                                    width: '100%',
                                    gap: '10px',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={500}
                                    color="primary">
                                    <span
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}>
                                        No :{' '}
                                    </span>
                                </Typography>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: '#DFE3EC',
                                        borderRadius: '14px',
                                        width: '50px',
                                        //padding:'2px'
                                    }}>
                                    {nocount}
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                //flexBasis: '180px',
                                flexGrow: 1,
                                margin: '5px 0px 0px 10px',
                                flexWrap: 'wrap',
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'left',
                                    alignItems: 'center',
                                    width: '100%',
                                    gap: '10px',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={500}
                                    color="primary">
                                    <span
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}>
                                        N/A :{' '}
                                    </span>
                                </Typography>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: '#DFE3EC',
                                        borderRadius: '14px',
                                        width: '50px',
                                        //padding:'2px'
                                    }}>
                                    {count}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    };



    return (
        <Box className={classes.boxContent}>
            <Box
                display="flex"
                flexDirection={'row'}
                justifyContent={'space-between'}
                margin={'16px 0px 0px 16px'}>
                <Box>
                    <Title
                        title={
                            props.moduleDisplayName
                                ? props.moduleDisplayName
                                : props.moduleToShow
                        }
                    />
                </Box>
                {props.showExpandCollapseValue && (
                    <Box>
                        <Tooltip title="Expand" aria-label="Expand">
                            <IconButton color="primary" onClick={onExpand}>
                                <AddCircleOutlinedIcon color="primary" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Collapse" aria-label="Collapse">
                            <IconButton color="primary" onClick={onCollapse}>
                                <RemoveCircleOutlinedIcon color="primary" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                )}
            </Box>
            {!props.hideModuleInfo &&
                props.moduleToShow != undefined &&
                eventState.eventDetail.get() &&
                ((moduleIndex.get() >= 0 &&
                    eventState.eventDetail.get().moduleDetails[
                        moduleIndex.get()
                    ].details != null) ||
                    '') && (
                    <DetailsComponent
                        data={
                            eventState.eventDetail.get().moduleDetails[
                                moduleIndex.get()
                            ].details
                        }
                    />
                )}
            {props.hideToolBar != undefined ? null : (
                <EnhancedTableToolbar
                    {...props}
                    search={search}
                    callAgentRoomExport={props.callAgentRoomExport}
                    showAgentRoomExport={props.showAgentRoomExport ? true : false}
                    showSendAll={props.showSendAll ? true : false}
                    sendAllbuttonTitle={props.showSendAll ? 'Send All' : null}
                    showEdit={props.showEdit ? true : false}
                    editButtonTitle={props.showEdit ? true : false}
                    handleSearchChange={handleOnChange}
                    handleFilterChange={handleFilterChangeValue}
                    handleSendEmail={props.handleSendEmail}
                    hideAdd={props.hideAdd ? true : false}
                    modPermission={props.modPermission}
                    disableAdd={props.disableAdd}
                    handleEditAll={handleEditAll}
                    handleHotelSave={handleHotelSave}
                    multiApprove={props.multiApprove}
                    multiReject={props.multiReject}
                    readOnlyOrHide={info && info.readonlyOrHide}
                    showApproveAndReject={
                        props.showApproveAndReject != undefined &&
                            props.showApproveAndReject === true
                            ? true
                            : false
                    }
                />
            )}
            <Box
                component="div"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '350px',
                    mb: 1,
                }}>
                {props.showRequestStatus ? (
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={14}
                        fontWeight={600}>
                        Pending :{' '}
                        {statusValues(
                            props.showRequestStatus.Pending,
                            'Pending'
                        )}
                    </Typography>
                ) : null}
                {props.showRequestStatus ? (
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={14}
                        fontWeight={600}>
                        Approved :{' '}
                        {statusValues(
                            props.showRequestStatus.Approved,
                            'Approved'
                        )}
                    </Typography>
                ) : null}
                {props.showRequestStatus ? (
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={14}
                        fontWeight={600}>
                        Not Approved :{' '}
                        {statusValues(
                            props.showRequestStatus.Rejected,
                            'Rejected'
                        )}
                    </Typography>
                ) : null}
            </Box>
            {props.showYesNoCount ?
                renderYesNoCount()
                : null}
            {props.isDraggable != undefined ? (
                <DraggableList
                    classes={classes}
                    data={filterListData}
                    onDragEnd={props.onDragEnd}
                    editRow={props.editRow}
                    modPermission={props.modPermission}
                />
            ) : (
                // <List className={classes.listContent}>
                //     {filterListData && filterListData.length > 0 ? (
                //         filterListData.map((item, index) => (
                //             <DataListRow
                //                 key={`datarow_${index}`}
                //                 item={item}
                //                 index={index}
                //                 onCheckSelect={onCheckSelect}
                //                 editRow={props.editRow}
                //                 viewPage={props.viewPage}
                //                 onSwitchToggle={props.onSwitchToggle}
                //                 onActionClick={props.onActionClick}
                //             />
                //         ))
                //     ) : (
                //         <ListItem className={classes.listItemContent}>
                //             <Card
                //                 classes={{ root: classes.paperContent }}
                //                 sx={{ width: '100%' }}>
                //                 <CardContent
                //                     sx={{ p: 2 }}
                //                     className={classes.cardContent}>
                //                     <Box className={classes.rowContent}>
                //                         No data found
                //                     </Box>
                //                 </CardContent>
                //             </Card>
                //         </ListItem>
                //     )}
                // </List>
                <>
                    {props.windowAccordDataList != undefined &&
                        props.windowAccordDataList ? (
                        <>
                            {props.loading && props.loading ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '100%',
                                        width: '100%',
                                        paddingTop: '10%',
                                    }}>
                                    <Box style={loader}>
                                        <CircularProgress />
                                    </Box>
                                </Box>
                            ) : filterListData && filterListData.length > 0 ? (
                                <>
                                    {hideSelectAll ? (
                                        <Box
                                            sx={{
                                                width: '100%',
                                                ml: 1,
                                                display: 'flex',
                                            }}>
                                            <Checkbox
                                                // color="secondary"
                                                checked={checkAllSelect}
                                                className={
                                                    classes.checkbox_style
                                                }
                                                onChange={(e) =>
                                                    onCheckSelectAll(e)
                                                }
                                                value={checkAllSelect}
                                            />

                                            <Typography sx={{ mt: 1 }}>
                                                Select All
                                            </Typography>
                                        </Box>
                                    ) : null}
                                    <WindowAccordList
                                        {...props}
                                        data={filterListData}
                                        onCheckSelect={onCheckSelect}
                                        modPermission={props.modPermission}
                                        editRow={props.editRow}
                                        rowType={props.rowType}
                                        hideReject={hideReject}
                                        hideApprove={hideApprove}
                                        expanded={expanded}
                                        moduleToShow={props.moduleToShow}
                                        readOnlyOrHide={
                                            info && info.readonlyOrHide
                                        }
                                        onSwitchToggle={props.onSwitchToggle}
                                        onToggleChange={props.onToggleChange}
                                    />
                                </>
                            ) : filterListData && filterListData.length == 0 ? (
                                <List className={classes.listContent}>
                                    <ListItem
                                        className={classes.listItemContent}>
                                        <Card
                                            classes={{
                                                root: classes.paperContent,
                                            }}
                                            sx={{ width: '100%' }}>
                                            <CardContent
                                                sx={{ p: 2 }}
                                                className={classes.cardContent}>
                                                <Box
                                                    className={
                                                        classes.rowContent
                                                    }>
                                                    No data found
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </ListItem>
                                </List>
                            ) : null}
                        </>
                    ) : (
                        <List className={classes.listContent}>
                            {props.loading && props.loading ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '100%',
                                        width: '100%',
                                        paddingTop: '10%',
                                    }}>
                                    <Box style={loader}>
                                        <CircularProgress />
                                    </Box>
                                </Box>
                            ) : (
                                <>
                                    {hideSelectAll &&
                                        filterListData &&
                                        filterListData.length > 0 && (
                                            <ListItem
                                                className={
                                                    classes.listItemContent
                                                }>
                                                <Box
                                                    sx={{
                                                        width: '100%',
                                                        ml: 1,
                                                        display: 'flex',
                                                    }}>
                                                    <Checkbox
                                                        // color="secondary"
                                                        checked={checkAllSelect}
                                                        className={
                                                            classes.checkbox_style
                                                        }
                                                        onChange={(e) =>
                                                            onCheckSelectAll(e)
                                                        }
                                                        value={checkAllSelect}
                                                    />

                                                    <Typography sx={{ mt: 1 }}>
                                                        Select All
                                                    </Typography>
                                                </Box>
                                            </ListItem>
                                        )}
                                    {filterListData &&
                                        filterListData.length > 0 ? (
                                        filterListData.map((item, index) => (
                                            <DataListRow
                                                {...props}
                                                key={`datarow_${index}`}
                                                item={item}
                                                index={index}
                                                onCheckSelect={onCheckSelect}
                                                editRow={props.editRow}
                                                editTemplate={
                                                    props.editTemplate
                                                }
                                                editSendEmail={
                                                    props.editSendEmail
                                                }
                                                viewPage={props.viewPage}
                                                onSwitchToggle={
                                                    props.onSwitchToggle
                                                }
                                                onActionClick={
                                                    props.onActionClick
                                                }
                                                onPendingAction={
                                                    props.onPendingAction
                                                }
                                                addConnection={
                                                    props.addConnection
                                                }
                                                addConnectionLinkedWith={
                                                    props.addConnectionLinkedWith
                                                }
                                                deleteConnection={
                                                    props.deleteConnection
                                                }
                                                modPermission={
                                                    props.modPermission
                                                }
                                                copyToClipboard={
                                                    props.copyToClipboard
                                                }
                                                outfitInfo={props.outfitInfo}
                                                moduleToShow={
                                                    props.moduleToShow
                                                }
                                                hideReject={hideReject}
                                                hideApprove={hideApprove}
                                                expanded={expanded}
                                                readOnlyOrHide={
                                                    info && info.readonlyOrHide
                                                }
                                            />
                                        ))
                                    ) : filterListData &&
                                        filterListData.length == 0 ? (
                                        <ListItem
                                            className={classes.listItemContent}>
                                            <Card
                                                classes={{
                                                    root: classes.paperContent,
                                                }}
                                                sx={{ width: '100%' }}>
                                                <CardContent
                                                    sx={{ p: 2 }}
                                                    className={
                                                        classes.cardContent
                                                    }>
                                                    <Box
                                                        className={
                                                            classes.rowContent
                                                        }>
                                                        No data found
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </ListItem>
                                    ) : null}{' '}
                                </>
                            )}
                        </List>
                    )}
                </>
            )}

            {/* {!props.loading && props.pagingInfo &&
                props.pagingInfo.noOfPages > 1 &&
                !props.showSearchRec ? (
                <Box
                    sx={{
                        p: 2,
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                    <Paging
                        pagingInfo={props.pagingInfo}
                        handlePageChange={props.handlePageChange}
                    />
                </Box>
            ) : null} */}
        </Box>
    );
};

export default DataList;


